module.exports = __webpack_public_path__ + "static/media/outer-space.0b39bb52.svg";